module.exports = __webpack_public_path__ + "2a12658b1ce2bcce73b3d9853a0e3e01.MP3";